import {NgHttpCachingBrowserStorage, NgHttpCachingStorageEntry} from './ng-http-caching-browser-storage';
import {NgHttpCachingEntry} from '../ng-http-caching.service';

const KEY_PREFIX = 'NgHttpCaching::';

export class NgHttpCachingLocalStorage extends NgHttpCachingBrowserStorage {

  constructor() {
    super(localStorage);
  }

  override set(key: string, value: NgHttpCachingEntry): void {
    if (!key) {
      return;
    }
    if (!key.startsWith(KEY_PREFIX)) {
      key = KEY_PREFIX + key;
    }
    const unParsedItem: NgHttpCachingStorageEntry = this.serialize(value);

    try {
      this.storage.setItem(key, JSON.stringify(unParsedItem));
    } catch (e) {
      if (e.name === "QuotaExceededError" || e.code === 22) {
        // Free up space by evicting the oldest entry
        this.evictOldest();
        // Retry once
        try {
          this.storage.setItem(key, JSON.stringify(unParsedItem));
        } catch {
          console.warn("LocalStorage: Could not save item even after eviction.");
        }
      } else {
        // Do not throw error, handle gracefully
        console.warn('LocalStorage: Error saving item to local storage', e);
        // throw e;
      }
    }
  }

  private evictOldest() {
    let oldestKey: string | null = null;
    let oldestTime = Infinity;

    for (let i = 0; i < this.storage.length; i++) {
      const storageKey = this.storage.key(i);
      if (!storageKey || !storageKey.startsWith(KEY_PREFIX)) {
        continue;
      }

      try {
        const raw = this.storage.getItem(storageKey);
        if (!raw) continue;

        const obj: NgHttpCachingStorageEntry = JSON.parse(raw);
        if (obj && typeof obj === "object" && "addedTime" in obj) {
          const time = obj.addedTime;
          if (time < oldestTime) {
            oldestTime = time;
            oldestKey = storageKey;
          }
        }
      } catch {
        // If parsing fails, treat as garbage and remove
        this.delete(storageKey);
      }
    }

    if (oldestKey) {
      console.warn(`LocalStorage: Evicting key "${oldestKey}" due to quota.`);
      this.delete(oldestKey);
    }
  }
}
